import React, { Component } from 'react';
import PropTypes from 'prop-types';
import className from 'classnames';
import styled from '@emotion/styled';

import { truncate } from 'Style/truncate';
import { getImageObject } from 'Utils/image-util';
import { getCampaignEditUrl } from 'Utils/content/flipboard-urls';
import { KEYS } from 'Utils/window-key-down';
import { pushPathToHistory } from 'Utils/history';
import { USAGE_EVENT_NAMES } from 'Utils/analytics/usage';

// Components
import WebLink from './web-link';
import Image from './base/image';

import withSelected from '../hocs/withSelected';
import withNavFrom from '../hocs/withNavFrom';
import withT from 'ComponentLibrary/hocs/withT';
import withHistory from 'Webapp/shared/app/hocs/withHistory';

import connector from 'Utils/connector';
import connectCurrentUser from 'Webapp/shared/app/connectors/connectCurrentUser';
import connectUsageSetNavFrom from 'Webapp/shared/app/connectors/connectUsageSetNavFrom';
import connectUsageTrackSectionTap from 'Webapp/shared/app/connectors/connectUsageTrackSectionTap';
import connectLanguage from 'Webapp/shared/app/connectors/connectLanguage';

const StyledWebLink = styled(WebLink)({
  '.section-tiles__title': truncate('92%', 5),
});

class CampaignTile extends Component {
  constructor(props) {
    super(props);

    this.state = { isPublishTooltipOpen: false, isAnalyticsTooltipOpen: false };
    this.tile = React.createRef();
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  handleKeyPress(event) {
    switch (event.keyCode) {
      case KEYS.ENTER: {
        const { currentUser, history, section } = this.props;
        const sectionPath = getCampaignEditUrl(
          currentUser.screenname,
          section.id,
        );
        sectionPath && pushPathToHistory(sectionPath, history);
        break;
      }
    }
  }

  render() {
    const { section, currentUser, selectedId, usageSetNavFrom, t } = this.props;

    const isSelected = selectedId === section.remoteid;
    const { title } = section;
    const selectedClass = className({
      'section-tiles__tile-wrapper': true,
      'section-tiles__tile-wrapper--selected': isSelected,
    });
    const tileClasses = className({
      'section-tiles__tile': true,
      'media-link': true,
    });
    const titleClasses = className({
      'section-tiles__title': true,
      'ui-text--title--small': true,
    });

    const alt = title ? `${title} - ${t('cover')}` : t('storyboard_cover');

    const tileProps = { ref: this.tile };
    if (isSelected) {
      tileProps.tabIndex = 0;
      tileProps.onKeyDown = this.handleKeyPress;
    }
    const image = section.image || getImageObject(section.coverUrl);

    return (
      <div {...tileProps} className={selectedClass}>
        <StyledWebLink
          href={getCampaignEditUrl(currentUser.screenname, section.id)}
          className={tileClasses}
          onClick={() =>
            usageSetNavFrom(
              USAGE_EVENT_NAMES.CURATOR_PRO_ENTER,
              this.props.navFrom,
            )
          }
        >
          <div className="section-tiles__image">
            {image && <Image image={image} alt={alt} crop />}
          </div>
          <div className="section-tiles__tile-overlay" />
          <div className="section-tiles__tile-content">
            <h3 className={titleClasses}>{title}</h3>
          </div>
        </StyledWebLink>
      </div>
    );
  }
}

CampaignTile.propTypes = {
  currentUser: PropTypes.object,
  history: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
  selectedId: PropTypes.string,
  navFrom: PropTypes.string,
  usageSetNavFrom: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};
CampaignTile.defaultProps = {
  selectedId: null,
  currentUser: null,
  shownInFeed: false,
  navFrom: null,
};

export default connector(
  connectUsageTrackSectionTap,
  connectUsageSetNavFrom,
  connectCurrentUser,
  connectLanguage,
)(withT(withHistory(withSelected(withNavFrom(CampaignTile)))));
